export const CTA_TYPE_CONFIRM_EMAIL = 'confirmEmail'
export const CTA_TYPE_COMPLETE_PROFILE = 'completeProfile'
export const CTA_TYPE_VERIFY = 'verifyYourself'
export const CTA_TYPE_NEW_USER_INFO = 'newUserInfo'

export type OnboardingCTAType = typeof CTA_TYPE_CONFIRM_EMAIL
| typeof CTA_TYPE_COMPLETE_PROFILE
| typeof CTA_TYPE_VERIFY
| typeof CTA_TYPE_NEW_USER_INFO;
